/**
 * @format
 */

import React from 'react';
import LeaderboardContainer from 'features/leaderboard/containers/LeaderboardContainer';
import { AgentLeaderboardFilterInput } from 'features/leaderboard/types/leaderboard.types';

interface AffiliateLeaderboardContainerProps {
  officeId?: string;
  startDate?: string;
  endDate?: string;
}

const AffiliateLeaderboardContainer: React.FC<AffiliateLeaderboardContainerProps> = ({ officeId, startDate, endDate }) => {
  const filter: AgentLeaderboardFilterInput = {
    officeId,
    startDate,
    endDate,
  };

  return (
    <div style={{ marginTop: '24px', width: '100%' }} >
      <LeaderboardContainer filter={filter} />
    </div>
  );
};

export default AffiliateLeaderboardContainer;
